module.exports = {
  modulo: 1,
  titulo: 'Datallog',
  paginas: ['Home Page', 'Soluções', 'FAQ', 'Cases', 'Blog', 'Consultas'],
};
